var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMagicWand = function SvgIconMagicWand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m12.735 6.856-9.906 9.906a1.75 1.75 0 0 0 0 2.475l1.939 1.939a1.75 1.75 0 0 0 2.475 0l13.94-13.941a1.75 1.75 0 0 0 0-2.475l-1.938-1.94a1.75 1.75 0 0 0-2.475 0l-3.914 3.915a1 1 0 0 0-.121.121M4.42 17.999l1.585 1.586 9.083-9.083-1.586-1.585zM14.917 7.502l1.585 1.586 3.09-3.09-1.584-1.586z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.375a1 1 0 0 1 1 1v.875h.875a1 1 0 0 1 0 2H8.5v.875a1 1 0 0 1-2 0V6.25h-.875a1 1 0 1 1 0-2H6.5v-.875a1 1 0 0 1 1-1M21.625 12a1 1 0 1 0-2 0v1.25h-1.25a1 1 0 1 0 0 2h1.25v1.25a1 1 0 1 0 2 0v-1.25h1.25a1 1 0 1 0 0-2h-1.25zM15.375 16.625a1 1 0 0 1 1 1v.5h.5a1 1 0 1 1 0 2h-.5v.5a1 1 0 1 1-2 0v-.5h-.5a1 1 0 1 1 0-2h.5v-.5a1 1 0 0 1 1-1"
  }))));
};
export default SvgIconMagicWand;